import { Stack } from "@altimateai/lego";
import { formatCost, formatMilliseconds } from "@/helpers/utils";
import { DbtModelRunSummary } from "@/pages/query/types";
import { useAppState } from "@/modules/app/useAppContext";
import { Skeleton } from "@altimateai/lego";

export const CommonTaskExecutionSummary = ({
  summary,
  isLoading = false,
}: {
  summary?: DbtModelRunSummary;
  isLoading?: boolean;
}) => {
  const { currency } = useAppState();

  return (
    <div className="al-grid al-grid-cols-4 al-gap-4">
      <Stack
        direction={"column"}
        gap={"sm"}
        className={"al-bg-white al-border al-p-3 al-rounded-md"}
      >
        <span className={"al-text-sm al-text-light-gray"}>Average Cost</span>
        {isLoading ? (
          <Skeleton className={"al-w-full al-h-4"} />
        ) : (
          <span className={"al-text-xl al-font-semibold"}>
            {summary ? formatCost(summary?.avg_cost, currency) : "NA"}
          </span>
        )}
      </Stack>
      <Stack
        direction={"column"}
        gap={"sm"}
        className={"al-bg-white al-border al-p-3 al-rounded-md"}
      >
        <span className={"al-text-sm al-text-light-gray"}>Maximum Cost</span>
        {isLoading ? (
          <Skeleton className={"al-w-full al-h-4"} />
        ) : (
          <span className={"al-text-xl al-font-semibold"}>
            {summary ? formatCost(summary?.total_cost, currency) : "NA"}
          </span>
        )}
      </Stack>
      <Stack
        direction={"column"}
        gap={"sm"}
        className={"al-bg-white al-border al-p-3 al-rounded-md"}
      >
        <span className={"al-text-sm al-text-light-gray"}>Average Run Time</span>
        {isLoading ? (
          <Skeleton className={"al-w-full al-h-4"} />
        ) : (
          <span className={"al-text-xl al-font-semibold"}>
            {summary ? formatMilliseconds(summary?.avg_execution_time) : "NA"}
          </span>
        )}
      </Stack>
      <Stack
        direction={"column"}
        gap={"sm"}
        className={"al-bg-white al-border al-p-3 al-rounded-md"}
      >
        <span className={"al-text-sm al-text-light-gray"}>Maximum Run Time</span>
        {isLoading ? (
          <Skeleton className={"al-w-full al-h-4"} />
        ) : (
          <span className={"al-text-xl al-font-semibold"}>
            {summary ? formatMilliseconds(summary?.max_execution_time) : "NA"}
          </span>
        )}
      </Stack>
    </div>
  );
};
